// tokens/src/colors.ts
var semantic = {
  accentAmber: {
    light: "#F46E38",
    dark: "#F3672E"
  },
  accentOcean: {
    light: "#3399FF",
    dark: "#2994FF"
  },
  accentPink: {
    light: "#FB60C4",
    dark: "#FB56C0"
  },
  accentPurple: {
    light: "#B141FF",
    dark: "#AD37FF"
  },
  accentRoyal: {
    light: "#3F6AFF",
    dark: "#3562FF"
  },
  accentScarlet: {
    light: "#FF4A4A",
    dark: "#FF4040"
  },
  accentSky: {
    light: "#00D4FF",
    dark: "#00CCF5"
  },
  accentSunshine: {
    light: "#FADA3D",
    dark: "#FAD833"
  },
  accentTurquoise: {
    light: "#41EBC1",
    dark: "#38EABE"
  },
  backgroundApp: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  backgroundBitcoin: {
    light: "#00C5F0",
    dark: "#00C5F0"
  },
  backgroundBrand: {
    light: "#00D64F",
    dark: "#00BD46"
  },
  backgroundDanger: {
    light: "#D3040E",
    dark: "#F84752"
  },
  backgroundDimmer: {
    light: "#00000073",
    dark: "#2A2A2AA6"
  },
  backgroundExtraProminent: {
    light: "#959595",
    dark: "#595959"
  },
  backgroundInverse: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  backgroundInversePressed: {
    light: "#666666",
    dark: "#878787"
  },
  backgroundInverseRipple: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  backgroundKeypad: {
    light: "#00B843",
    dark: "#000000"
  },
  backgroundNotification: {
    light: "#D7040E",
    dark: "#D7040E"
  },
  backgroundProminent: {
    light: "#CCCCCC",
    dark: "#333333"
  },
  backgroundRipple: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  backgroundStandard: {
    light: "#E8E8E8",
    dark: "#232323"
  },
  backgroundSubtle: {
    light: "#F0F0F0",
    dark: "#1A1A1A"
  },
  backgroundWarning: {
    light: "#CC4B03",
    dark: "#F46E38"
  },
  borderApp: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  borderBrand: {
    light: "#00D64F",
    dark: "#00BD46"
  },
  borderDanger: {
    light: "#D3040E",
    dark: "#F84752"
  },
  borderDivider: {
    light: "#E8E8E8",
    dark: "#232323"
  },
  borderInverse: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  borderProminent: {
    light: "#101010",
    dark: "#FFFFFF"
  },
  borderStandard: {
    light: "#959595",
    dark: "#595959"
  },
  borderSubtle: {
    light: "#E8E8E8",
    dark: "#232323"
  },
  borderSuccess: {
    light: "#00792C",
    dark: "#00D149"
  },
  borderWarning: {
    light: "#CC4B03",
    dark: "#F46E38"
  },
  iconBrand: {
    light: "#00D64F",
    dark: "#00BD46"
  },
  iconDanger: {
    light: "#D3040E",
    dark: "#F84752"
  },
  iconDisabled: {
    light: "#959595",
    dark: "#595959"
  },
  iconExtraSubtle: {
    light: "#959595",
    dark: "#595959"
  },
  iconInfo: {
    light: "#007CC1",
    dark: "#2B8DE7"
  },
  iconInverse: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  iconProminent: {
    light: "#101010",
    dark: "#FFFFFF"
  },
  iconStandard: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  iconSubtle: {
    light: "#666666",
    dark: "#878787"
  },
  iconSuccess: {
    light: "#00792C",
    dark: "#00D149"
  },
  iconWarning: {
    light: "#CC4B03",
    dark: "#F46E38"
  },
  illustrationFillBrand: {
    light: "#00D64F",
    dark: "#00BD46"
  },
  illustrationFillProminent: {
    light: "#FFFFFF",
    dark: "#E8E8E8"
  },
  illustrationFillStandard: {
    light: "#000000",
    dark: "#000000"
  },
  illustrationFillSubtle: {
    light: "#959595",
    dark: "#878787"
  },
  illustrationShadowStandard: {
    light: "#000000",
    dark: "#595959"
  },
  illustrationStrokeProminent: {
    light: "#000000",
    dark: "#E8E8E8"
  },
  illustrationStrokeStandard: {
    light: "#000000",
    dark: "#000000"
  },
  illustrationStrokeSubtle: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  serviceBitcoin: {
    light: "#00D4FF",
    dark: "#00D4FF"
  },
  serviceBitcoinBackground: {
    light: "#00C5F0",
    dark: "#00C5F0"
  },
  serviceBitcoinOrange: {
    light: "#F78A2B",
    dark: "#F78A2B"
  },
  serviceBitcoinPressed: {
    light: "#00BDE6",
    dark: "#00C7F0"
  },
  serviceBorrow: {
    light: "#3399FF",
    dark: "#3399FF"
  },
  serviceInvesting: {
    light: "#9013FE",
    dark: "#B141FF"
  },
  serviceTaxes: {
    light: "#5D00E8",
    dark: "#9378FF"
  },
  serviceTaxesBackground: {
    light: "#4B00BA",
    dark: "#32007A"
  },
  textBrand: {
    light: "#00D64F",
    dark: "#00BD46"
  },
  textDanger: {
    light: "#D3040E",
    dark: "#F84752"
  },
  textDisabled: {
    light: "#959595",
    dark: "#595959"
  },
  textInverse: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  textLink: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  textLinkVisited: {
    light: "#660199",
    dark: "#AC8EFF"
  },
  textPlaceholder: {
    light: "#666666",
    dark: "#878787"
  },
  textProminent: {
    light: "#101010",
    dark: "#FFFFFF"
  },
  textStandard: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  textSubtle: {
    light: "#666666",
    dark: "#878787"
  },
  textSuccess: {
    light: "#00792C",
    dark: "#00D149"
  },
  textWarning: {
    light: "#CC4B03",
    dark: "#F46E38"
  }
};
var component = {
  buttonDestructiveProminentBackgroundDefault: {
    light: "#D3040E",
    dark: "#F84752"
  },
  buttonDestructiveProminentBackgroundDisabled: {
    light: "#F3B4B7",
    dark: "#4A1316"
  },
  buttonDestructiveProminentBackgroundPressed: {
    light: "#90030A",
    dark: "#FA7E86"
  },
  buttonDestructiveProminentIconDefault: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  buttonDestructiveProminentIconDisabled: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  buttonDestructiveProminentTextDefault: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  buttonDestructiveProminentTextDisabled: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  buttonDestructiveStandardBackgroundDefault: {
    light: "#E8E8E8",
    dark: "#232323"
  },
  buttonDestructiveStandardBackgroundDisabled: {
    light: "#F0F0F0",
    dark: "#1A1A1A"
  },
  buttonDestructiveStandardBackgroundPressed: {
    light: "#CCCCCC",
    dark: "#333333"
  },
  buttonDestructiveStandardIconDefault: {
    light: "#D3040E",
    dark: "#F84752"
  },
  buttonDestructiveStandardIconDisabled: {
    light: "#F3B4B7",
    dark: "#4A1316"
  },
  buttonDestructiveStandardIconPressed: {
    light: "#90030A",
    dark: "#FA6F8F"
  },
  buttonDestructiveStandardTextDefault: {
    light: "#D3040E",
    dark: "#F84752"
  },
  buttonDestructiveStandardTextDisabled: {
    light: "#F3B4B7",
    dark: "#4A1316"
  },
  buttonDestructiveStandardTextPressed: {
    light: "#90030A",
    dark: "#FA6F8F"
  },
  buttonDestructiveSubtleBackgroundDefault: {
    light: "#00000000",
    dark: "#00000000"
  },
  buttonDestructiveSubtleBackgroundPressed: {
    light: "#F7CDCF",
    dark: "#320D0F"
  },
  buttonDestructiveSubtleIconDefault: {
    light: "#D3040E",
    dark: "#F84752"
  },
  buttonDestructiveSubtleIconDisabled: {
    light: "#F3B4B7",
    dark: "#4A1316"
  },
  buttonDestructiveSubtleIconPressed: {
    light: "#90030A",
    dark: "#FA6F8F"
  },
  buttonDestructiveSubtleTextDefault: {
    light: "#D3040E",
    dark: "#F84752"
  },
  buttonDestructiveSubtleTextDisabled: {
    light: "#F3B4B7",
    dark: "#4A1316"
  },
  buttonDestructiveSubtleTextPressed: {
    light: "#90030A",
    dark: "#FA6F8F"
  },
  buttonProminentBackgroundDefault: {
    light: "#00D64F",
    dark: "#00BD46"
  },
  buttonProminentBackgroundDisabled: {
    light: "#00D64F4D",
    dark: "#00BD464D"
  },
  buttonProminentBackgroundHover: {
    light: "#00A93A",
    dark: "#008431"
  },
  buttonProminentBackgroundPressed: {
    light: "#00A93E",
    dark: "#005620"
  },
  buttonProminentIconDefault: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  buttonProminentIconDisabled: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  buttonProminentTextDefault: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  buttonProminentTextDisabled: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  buttonProminentTextPressed: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  buttonStandardBackgroundDefault: {
    light: "#E8E8E8",
    dark: "#232323"
  },
  buttonStandardBackgroundDisabled: {
    light: "#F0F0F0",
    dark: "#1A1A1A"
  },
  buttonStandardBackgroundFocus: {
    light: "#E8E8E81A",
    dark: "#2323231A"
  },
  buttonStandardBackgroundHover: {
    light: "#CCCCCC",
    dark: "#878787"
  },
  buttonStandardBackgroundPressed: {
    light: "#CCCCCC",
    dark: "#333333"
  },
  buttonStandardIconDefault: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  buttonStandardIconDisabled: {
    light: "#959595",
    dark: "#595959"
  },
  buttonStandardTextDefault: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  buttonStandardTextDisabled: {
    light: "#959595",
    dark: "#595959"
  },
  buttonSubtleBackgroundDefault: {
    light: "#00000000",
    dark: "#00000000"
  },
  buttonSubtleBackgroundDisabled: {
    light: "#00000000",
    dark: "#00000000"
  },
  buttonSubtleBackgroundFocus: {
    light: "#00D64F1A",
    dark: "#00BD461A"
  },
  buttonSubtleBackgroundHover: {
    light: "#00D64F33",
    dark: "#00BD4633"
  },
  buttonSubtleBackgroundPressed: {
    light: "#00D64F33",
    dark: "#00BD4633"
  },
  buttonSubtleIconDefault: {
    light: "#00D64F",
    dark: "#00BD46"
  },
  buttonSubtleIconDisabled: {
    light: "#959595",
    dark: "#595959"
  },
  buttonSubtleIconPressed: {
    light: "#00BD46",
    dark: "#4ED17F"
  },
  buttonSubtleTextDefault: {
    light: "#00D64F",
    dark: "#00BD46"
  },
  buttonSubtleTextDisabled: {
    light: "#959595",
    dark: "#595959"
  },
  buttonSubtleTextPressed: {
    light: "#00BD46",
    dark: "#4ED17F"
  },
  cellBackgroundDefault: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  cellBackgroundHover: {
    light: "#F0F0F0",
    dark: "#1A1A1A"
  },
  cellBackgroundPressed: {
    light: "#CCCCCC",
    dark: "#333333"
  },
  cellBodyDefault: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  cellBodyDisabled: {
    light: "#959595",
    dark: "#595959"
  },
  cellLabelDefault: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  cellLabelDisabled: {
    light: "#959595",
    dark: "#595959"
  },
  checkboxActiveBackgroundDefault: {
    light: "#00D64F",
    dark: "#00BD46"
  },
  checkboxActiveBackgroundDisabled: {
    light: "#00D64F4D",
    dark: "#00BD464D"
  },
  checkboxActiveBackgroundPressed: {
    light: "#00D64F66",
    dark: "#00BD4666"
  },
  checkboxActiveBorderDefault: {
    light: "#00000000",
    dark: "#00000000"
  },
  checkboxActiveIcon: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  checkboxInactiveBackgroundPressed: {
    light: "#F0F0F0",
    dark: "#1A1A1A"
  },
  checkboxInactiveBorderDefault: {
    light: "#959595",
    dark: "#595959"
  },
  checkboxInactiveBorderDisabled: {
    light: "#E8E8E8",
    dark: "#232323"
  },
  copyCodeBackgroundDefault: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  copyCodeBackgroundPressed: {
    light: "#CCCCCC",
    dark: "#333333"
  },
  copyCodeIconDefault: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  copyCodeSuccessBackground: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  copyCodeSuccessBorder: {
    light: "#00792C",
    dark: "#00D149"
  },
  copyCodeSuccessIcon: {
    light: "#00792C",
    dark: "#00D149"
  },
  halfsheetBackground: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  inputBackgroundDefault: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  inputBackgroundPressed: {
    light: "#CCCCCC",
    dark: "#333333"
  },
  inputBackgroundSelectedDefault: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  inputBackgroundSelectedPressed: {
    light: "#CCCCCC",
    dark: "#333333"
  },
  inputBorderDefault: {
    light: "#959595",
    dark: "#595959"
  },
  inputBorderDisabled: {
    light: "#E8E8E8",
    dark: "#232323"
  },
  inputBorderError: {
    light: "#D3040E",
    dark: "#F84752"
  },
  inputBorderFocus: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  inputBorderHover: {
    light: "#666666",
    dark: "#878787"
  },
  inputBorderSelectedDefault: {
    light: "#00D64F",
    dark: "#00BD46"
  },
  inputBorderSelectedPressed: {
    light: "#00D64F",
    dark: "#00BD46"
  },
  inputCursor: {
    light: "#00D64F",
    dark: "#00BD46"
  },
  inputHelperIcon: {
    light: "#666666",
    dark: "#878787"
  },
  inputHelperTextDefault: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  inputHelperTextError: {
    light: "#D3040E",
    dark: "#F84752"
  },
  inputIconLeadingDefault: {
    light: "#666666",
    dark: "#878787"
  },
  inputIconLeadingDisabled: {
    light: "#959595",
    dark: "#595959"
  },
  inputIconLeadingPressed: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  inputIconTrailingDefault: {
    light: "#666666",
    dark: "#878787"
  },
  inputIconTrailingDisabled: {
    light: "#959595",
    dark: "#595959"
  },
  inputIconTrailingError: {
    light: "#D3040E",
    dark: "#F84752"
  },
  inputIconTrailingPressed: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  inputLabelDefault: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  inputLabelDisabled: {
    light: "#959595",
    dark: "#595959"
  },
  inputTextDefault: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  inputTextDisabled: {
    light: "#959595",
    dark: "#595959"
  },
  inputTextPlaceholder: {
    light: "#666666",
    dark: "#878787"
  },
  modalBackground: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  modalButtonDestructiveBackgroundPressed: {
    light: "#CCCCCC",
    dark: "#333333"
  },
  modalButtonDestructiveTextDefault: {
    light: "#D3040E",
    dark: "#F84752"
  },
  modalButtonDestructiveTextDisabled: {
    light: "#F3B4B7",
    dark: "#4A1316"
  },
  modalButtonDestructiveTextPressed: {
    light: "#90030A",
    dark: "#FA6F8F"
  },
  modalButtonPrimaryBackgroundPressed: {
    light: "#CCCCCC",
    dark: "#333333"
  },
  modalButtonPrimaryTextDefault: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  modalButtonPrimaryTextDisabled: {
    light: "#959595",
    dark: "#595959"
  },
  modalButtonSecondaryBackgroundPressed: {
    light: "#CCCCCC",
    dark: "#333333"
  },
  modalButtonSecondaryTextDefault: {
    light: "#666666",
    dark: "#878787"
  },
  modalButtonSecondaryTextDisabled: {
    light: "#959595",
    dark: "#595959"
  },
  radioActiveBackgroundPressed: {
    light: "#00D64F66",
    dark: "#00BD4666"
  },
  radioActiveBorderDefault: {
    light: "#00D64F",
    dark: "#00BD46"
  },
  radioActiveBorderDisabled: {
    light: "#00D64F4D",
    dark: "#00BD464D"
  },
  radioInactiveBackgroundPressed: {
    light: "#F0F0F0",
    dark: "#1A1A1A"
  },
  radioInactiveBorderDefault: {
    light: "#959595",
    dark: "#595959"
  },
  radioInactiveBorderDisabled: {
    light: "#E8E8E8",
    dark: "#232323"
  },
  searchBarBackground: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  searchBarIconDefault: {
    light: "#666666",
    dark: "#878787"
  },
  searchBarIconPressed: {
    light: "#959595",
    dark: "#595959"
  },
  searchBarTextDefault: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  searchBarTextPressed: {
    light: "#666666",
    dark: "#878787"
  },
  searchFieldBackgroundDefault: {
    light: "#F0F0F0",
    dark: "#1A1A1A"
  },
  searchFieldBackgroundPressed: {
    light: "#CCCCCC",
    dark: "#333333"
  },
  searchFieldIconDefault: {
    light: "#666666",
    dark: "#878787"
  },
  searchFieldIconPressed: {
    light: "#959595",
    dark: "#595959"
  },
  searchFieldPlaceholder: {
    light: "#666666",
    dark: "#878787"
  },
  searchFieldText: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  segmentedControlBackgroundDefault: {
    light: "#E8E8E8",
    dark: "#232323"
  },
  segmentedControlBackgroundPressed: {
    light: "#CCCCCC",
    dark: "#333333"
  },
  segmentedControlButtonBackgroundSelected: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  segmentedControlButtonText: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  timelineBackgroundDefault: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  timelineBackgroundPressed: {
    light: "#CCCCCC",
    dark: "#333333"
  },
  timelineDotBackgroundCollapsed: {
    light: "#101010",
    dark: "#FFFFFF"
  },
  timelineDotBackgroundDone: {
    light: "#101010",
    dark: "#FFFFFF"
  },
  timelineDotBackgroundInProgress: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  timelineDotBackgroundNotStarted: {
    light: "#F0F0F0",
    dark: "#1A1A1A"
  },
  timelineDotBackgroundPending: {
    light: "#101010",
    dark: "#FFFFFF"
  },
  timelineDotBackgroundSkipped: {
    light: "#101010",
    dark: "#FFFFFF"
  },
  timelineDotBorderInProgress: {
    light: "#101010",
    dark: "#FFFFFF"
  },
  timelineLineBorderCollapsed: {
    light: "#101010",
    dark: "#FFFFFF"
  },
  timelineLineBorderDone: {
    light: "#101010",
    dark: "#FFFFFF"
  },
  timelineLineBorderInProgress: {
    light: "#101010",
    dark: "#FFFFFF"
  },
  timelineLineBorderNotStarted: {
    light: "#F0F0F0",
    dark: "#1A1A1A"
  },
  timelineLineBorderPending: {
    light: "#101010",
    dark: "#FFFFFF"
  },
  timelineLineBorderSkipped: {
    light: "#101010",
    dark: "#FFFFFF"
  },
  toastBackgroundDefault: {
    light: "#232323",
    dark: "#E8E8E8"
  },
  toastButtonBackgroundDefault: {
    light: "#232323",
    dark: "#E8E8E8"
  },
  toastButtonBackgroundPressed: {
    light: "#333333",
    dark: "#CCCCCC"
  },
  toggleActiveBackgroundDefault: {
    light: "#00D64F",
    dark: "#00BD46"
  },
  toggleActiveBackgroundDisabled: {
    light: "#00D64FBF",
    dark: "#00BD46BF"
  },
  toggleInactiveBackgroundDefault: {
    light: "#E8E8E8",
    dark: "#232323"
  },
  toggleInactiveBackgroundDisabled: {
    light: "#F0F0F0",
    dark: "#1A1A1A"
  },
  toggleKnobBackgroundDefault: {
    light: "#FFFFFF",
    dark: "#FFFFFF"
  },
  toggleKnobBackgroundDisabled: {
    light: "#FFFFFFBF",
    dark: "#FFFFFFBF"
  },
  uiDividerBorder: {
    light: "#E8E8E8",
    dark: "#232323"
  },
  uiHandleBorder: {
    light: "#959595",
    dark: "#595959"
  }
};

// tokens/src/colors-mono.ts
var semantic2 = {
  accentAmber: {
    light: "#F46E38",
    dark: "#F3672E"
  },
  accentOcean: {
    light: "#3399FF",
    dark: "#2994FF"
  },
  accentPink: {
    light: "#FB60C4",
    dark: "#FB56C0"
  },
  accentPurple: {
    light: "#B141FF",
    dark: "#AD37FF"
  },
  accentRoyal: {
    light: "#3F6AFF",
    dark: "#3562FF"
  },
  accentScarlet: {
    light: "#FF4A4A",
    dark: "#FF4040"
  },
  accentSky: {
    light: "#00D4FF",
    dark: "#00CCF5"
  },
  accentSunshine: {
    light: "#FADA3D",
    dark: "#FAD833"
  },
  accentTurquoise: {
    light: "#41EBC1",
    dark: "#38EABE"
  },
  backgroundApp: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  backgroundBitcoin: {
    light: "#00C5F0",
    dark: "#00C5F0"
  },
  backgroundBrand: {
    light: "#00D64F",
    dark: "#00BD46"
  },
  backgroundDanger: {
    light: "#D3040E",
    dark: "#F84752"
  },
  backgroundDimmer: {
    light: "#00000073",
    dark: "#2A2A2AA6"
  },
  backgroundExtraProminent: {
    light: "#959595",
    dark: "#595959"
  },
  backgroundInverse: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  backgroundInversePressed: {
    light: "#666666",
    dark: "#878787"
  },
  backgroundInverseRipple: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  backgroundKeypad: {
    light: "#00B843",
    dark: "#000000"
  },
  backgroundNotification: {
    light: "#D7040E",
    dark: "#D7040E"
  },
  backgroundProminent: {
    light: "#CCCCCC",
    dark: "#333333"
  },
  backgroundRipple: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  backgroundStandard: {
    light: "#E8E8E8",
    dark: "#232323"
  },
  backgroundSubtle: {
    light: "#F0F0F0",
    dark: "#1A1A1A"
  },
  backgroundWarning: {
    light: "#CC4B03",
    dark: "#F46E38"
  },
  borderApp: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  borderBrand: {
    light: "#00D64F",
    dark: "#00BD46"
  },
  borderDanger: {
    light: "#D3040E",
    dark: "#F84752"
  },
  borderDivider: {
    light: "#E8E8E8",
    dark: "#232323"
  },
  borderInverse: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  borderProminent: {
    light: "#101010",
    dark: "#FFFFFF"
  },
  borderStandard: {
    light: "#959595",
    dark: "#595959"
  },
  borderSubtle: {
    light: "#E8E8E8",
    dark: "#232323"
  },
  borderSuccess: {
    light: "#00792C",
    dark: "#00D149"
  },
  borderSuccessP3: {
    lightP3: "#00792C"
  },
  borderWarning: {
    light: "#CC4B03",
    dark: "#F46E38"
  },
  iconBrand: {
    light: "#00D64F",
    dark: "#00BD46"
  },
  iconDanger: {
    light: "#D3040E",
    dark: "#F84752"
  },
  iconDisabled: {
    light: "#959595",
    dark: "#595959"
  },
  iconExtraSubtle: {
    light: "#959595",
    dark: "#595959"
  },
  iconInfo: {
    light: "#007CC1",
    dark: "#2B8DE7"
  },
  iconInverse: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  iconProminent: {
    light: "#101010",
    dark: "#FFFFFF"
  },
  iconStandard: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  iconSubtle: {
    light: "#666666",
    dark: "#878787"
  },
  iconSuccess: {
    light: "#00792C",
    dark: "#00D149"
  },
  iconSuccessP3: {
    lightP3: "#00792C"
  },
  iconWarning: {
    light: "#CC4B03",
    dark: "#F46E38"
  },
  illustrationFillBrand: {
    light: "#00D64F",
    dark: "#00BD46"
  },
  illustrationFillProminent: {
    light: "#FFFFFF",
    dark: "#E8E8E8"
  },
  illustrationFillStandard: {
    light: "#000000",
    dark: "#000000"
  },
  illustrationFillSubtle: {
    light: "#959595",
    dark: "#878787"
  },
  illustrationShadowStandard: {
    light: "#000000",
    dark: "#595959"
  },
  illustrationStrokeProminent: {
    light: "#000000",
    dark: "#E8E8E8"
  },
  illustrationStrokeStandard: {
    light: "#000000",
    dark: "#000000"
  },
  illustrationStrokeSubtle: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  serviceBitcoin: {
    light: "#00D4FF",
    dark: "#00D4FF"
  },
  serviceBitcoinBackground: {
    light: "#00C5F0",
    dark: "#00C5F0"
  },
  serviceBitcoinOrange: {
    light: "#F78A2B",
    dark: "#F78A2B"
  },
  serviceBitcoinPressed: {
    light: "#00BDE6",
    dark: "#00C7F0"
  },
  serviceBorrow: {
    light: "#3399FF",
    dark: "#3399FF"
  },
  serviceInvesting: {
    light: "#9013FE",
    dark: "#B141FF"
  },
  serviceTaxes: {
    light: "#5D00E8",
    dark: "#9378FF"
  },
  serviceTaxesBackground: {
    light: "#4B00BA",
    dark: "#32007A"
  },
  textBrand: {
    light: "#00D64F",
    dark: "#00BD46"
  },
  textDanger: {
    light: "#D3040E",
    dark: "#F84752"
  },
  textDisabled: {
    light: "#959595",
    dark: "#595959"
  },
  textInverse: {
    light: "#FFFFFF",
    dark: "#000000"
  },
  textLink: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  textLinkVisited: {
    light: "#660199",
    dark: "#AC8EFF"
  },
  textPlaceholder: {
    light: "#666666",
    dark: "#878787"
  },
  textProminent: {
    light: "#101010",
    dark: "#FFFFFF"
  },
  textStandard: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  textSubtle: {
    light: "#666666",
    dark: "#878787"
  },
  textSuccess: {
    light: "#00792C",
    dark: "#00D149"
  },
  textSuccessP3: {
    lightP3: "#00792C"
  },
  textWarning: {
    light: "#CC4B03",
    dark: "#F46E38"
  }
};
var component2 = {
  buttonDestructiveProminentBackgroundHover: {
    light: "#ED474F",
    dark: "#FF8189"
  },
  buttonDestructiveStandardBackgroundHover: {
    light: "#D9D9D9",
    dark: "#404040"
  },
  buttonDestructiveSubtleBackgroundHover: {
    light: "#FFEBEC",
    dark: "#481D1F"
  },
  buttonProminentBackgroundDefault: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  buttonProminentBackgroundDisabled: {
    light: "#0000004D",
    dark: "#FFFFFF4D"
  },
  buttonProminentBackgroundHover: {
    light: "#737373",
    dark: "#CCCCCC"
  },
  buttonProminentBackgroundPressed: {
    light: "#666666",
    dark: "#878787"
  },
  buttonStandardBackgroundHover: {
    light: "#D9D9D9",
    dark: "#404040"
  },
  buttonSubtleBackgroundHover: {
    light: "#D9D9D9",
    dark: "#404040"
  },
  buttonSubtleBackgroundPressed: {
    light: "#00000033",
    dark: "#FFFFFF33"
  },
  buttonSubtleIconDefault: {
    light: "#101010",
    dark: "#FFFFFF"
  },
  buttonSubtleIconPressed: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  buttonSubtleTextDefault: {
    light: "#101010",
    dark: "#FFFFFF"
  },
  buttonSubtleTextPressed: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  cellBackgroundHover: {
    light: "#E8E8E8",
    dark: "#333333"
  },
  checkboxActiveBackgroundDefault: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  checkboxActiveBackgroundDisabled: {
    light: "#0000004D",
    dark: "#FFFFFF4D"
  },
  checkboxActiveBackgroundHover: {
    light: "#737373",
    dark: "#CCCCCC"
  },
  checkboxActiveBackgroundPressed: {
    light: "#00000033",
    dark: "#FFFFFF33"
  },
  checkboxInactiveBorderHover: {
    light: "#666666",
    dark: "#878787"
  },
  inputBorderHover: {
    light: "#878787",
    dark: "#878787"
  },
  inputBorderSelectedDefault: {
    light: "#101010",
    dark: "#FFFFFF"
  },
  inputBorderSelectedPressed: {
    light: "#959595",
    dark: "#595959"
  },
  inputCursor: {
    light: "#101010",
    dark: "#FFFFFF"
  },
  inputIconHover: {
    light: "#262626",
    dark: "#999999"
  },
  radioActiveBackgroundHover: {
    light: "#737373",
    dark: "#CCCCCC"
  },
  radioActiveBackgroundPressed: {
    light: "#00000033",
    dark: "#FFFFFF33"
  },
  radioActiveBorderDefault: {
    light: "#000000",
    dark: "#FFFFFF"
  },
  radioActiveBorderDisabled: {
    light: "#0000004D",
    dark: "#FFFFFF4D"
  },
  radioInactiveBorderHover: {
    light: "#666666",
    dark: "#878787"
  },
  searchFieldBackgroundHover: {
    light: "#E8E8E8",
    dark: "#404040"
  },
  toastButtonBackgroundHover: {
    light: "#404040",
    dark: "#D9D9D9"
  }
};

// tokens/src/spacing.ts
var size = {
  0: "0rem",
  1: "0.25rem",
  2: "0.5rem",
  3: "0.75rem",
  4: "1rem",
  5: "1.25rem",
  6: "1.5rem",
  7: "1.75rem",
  8: "2rem",
  9: "2.25rem",
  10: "2.5rem",
  11: "2.75rem",
  12: "3rem",
  14: "3.5rem",
  16: "4rem",
  20: "5rem",
  24: "6rem",
  28: "7rem",
  30: "7.5rem",
  32: "8rem",
  36: "9rem",
  40: "10rem",
  44: "11rem",
  48: "12rem",
  52: "13rem",
  56: "14rem",
  60: "15rem",
  64: "16rem",
  72: "18rem",
  80: "20rem",
  96: "24rem",
  0.25: "0.0625rem",
  0.5: "0.125rem",
  1.5: "0.375rem",
  2.5: "0.625rem",
  3.5: "0.875rem"
};
var border = {
  radius: {
    xsmall: "0.375rem",
    small: "0.5rem",
    medium: "1rem",
    large: "1.5rem",
    xlarge: "2.5rem",
    pill: "624.9375rem",
    circle: "50%"
  },
  width: {
    small: "0.0625rem",
    medium: "0.125rem",
    large: "0.5rem"
  }
};

// tokens/src/viewport.ts
var viewport = {
  /**
   * The minimum content width supported for any mobile viewport
   */
  min: "320px",
  /**
   * The minimum viewport width for tablet devices
   */
  small: "760px",
  /**
   * The minimum viewport width for laptop / medium size displays
   */
  medium: "1024px",
  /**
   * The minimum viewport width for desktop / wide displays
   */
  large: "1440px",
  /**
   * The maximum content width we want to allow for any viewport
   */
  max: "1680px"
};

// tokens/src/media-query.ts
var mediaQuery = {
  /**
   * Targets device width >= 760px
   */
  tablet: `@media (min-width: ${viewport.small})`,
  /**
   * Targets device width >= 1024px
   */
  desktop: `@media (min-width: ${viewport.medium})`,
  /**
   * Targets device width >= 1440px
   */
  widescreen: `@media (min-width: ${viewport.large})`
};

// tokens/src/typography.ts
var typography = {
  badgeLargeAsset: {
    fontSize: "0.6875rem",
    fontWeight: 400,
    lineHeight: "1rem",
    letterSpacing: "0.03125rem"
  },
  badgeLargeInline: {
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: "1.25rem",
    letterSpacing: "-0.0021875rem"
  },
  body: {
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: "1.5rem",
    letterSpacing: "0.03125rem"
  },
  bodyLink: {
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: "1.5rem",
    letterSpacing: "0.09375rem"
  },
  bodyMedium: {
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: "1.5rem",
    letterSpacing: "-0.005rem"
  },
  bodySmall: {
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: "1.25rem",
    letterSpacing: "-0.0021875rem"
  },
  bodyXSmall: {
    fontSize: "0.625rem",
    fontWeight: 400,
    lineHeight: "1rem",
    letterSpacing: "0.01875rem"
  },
  button: {
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: "1.5rem",
    letterSpacing: "0rem"
  },
  buttonCompact: {
    fontSize: "0.875rem",
    fontWeight: 500,
    lineHeight: "1rem",
    letterSpacing: "0.0021875rem"
  },
  buttonCompactUnderline: {
    fontSize: "0.875rem",
    fontWeight: 500,
    lineHeight: "1rem",
    letterSpacing: "0.0021875rem"
  },
  buttonUnderline: {
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: "1.5rem",
    letterSpacing: "0rem"
  },
  cellBody: {
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: "1.25rem",
    letterSpacing: "0.0625rem"
  },
  disclaimer: {
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: "1.25rem",
    letterSpacing: "0.0625rem"
  },
  disclaimerLink: {
    fontSize: "0.875rem",
    fontWeight: 500,
    lineHeight: "1.25rem",
    letterSpacing: "0.0625rem"
  },
  header: {
    fontSize: "1.75rem",
    fontWeight: 500,
    lineHeight: "2rem",
    letterSpacing: "0rem"
  },
  headlineLarge: {
    fontSize: "2.75rem",
    fontWeight: 400,
    lineHeight: "2.75rem",
    letterSpacing: "-0.089375rem"
  },
  headlineSmall: {
    fontSize: "2rem",
    fontWeight: 400,
    lineHeight: "2rem",
    letterSpacing: "-0.05rem"
  },
  helpText: {
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: "1.25rem",
    letterSpacing: "-0.0021875rem"
  },
  hero: {
    fontSize: "3.5rem",
    fontWeight: 400,
    lineHeight: "3.5rem",
    letterSpacing: "-0.14rem"
  },
  heroNumerics: {
    fontSize: "3rem",
    fontWeight: 600,
    lineHeight: "3.25rem",
    letterSpacing: "0.0125rem"
  },
  input: {
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: "1.5rem",
    letterSpacing: "-0.005rem"
  },
  keypadNumbers: {
    fontSize: "1.5rem",
    fontWeight: 500,
    lineHeight: "1.75rem",
    letterSpacing: "0rem"
  },
  keypadTotal: {
    fontSize: "6rem",
    fontWeight: 500,
    lineHeight: "6rem",
    letterSpacing: "0rem"
  },
  label: {
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: "1.5rem",
    letterSpacing: "0.09375rem"
  },
  labelMedium: {
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: "1.5rem",
    letterSpacing: "0rem"
  },
  labelSmall: {
    fontSize: "0.875rem",
    fontWeight: 500,
    lineHeight: "1.25rem",
    letterSpacing: "0.0021875rem"
  },
  labelXSmall: {
    fontSize: "0.625rem",
    fontWeight: 500,
    lineHeight: "1rem",
    letterSpacing: "0.0375rem"
  },
  largeLabel: {
    fontSize: "2rem",
    fontWeight: 600,
    lineHeight: "2.25rem",
    letterSpacing: "0rem"
  },
  linkMedium: {
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: "1.5rem",
    letterSpacing: "0rem"
  },
  linkSmall: {
    fontSize: "0.875rem",
    fontWeight: 500,
    lineHeight: "1.25rem",
    letterSpacing: "0.0021875rem"
  },
  linkXSmall: {
    fontSize: "0.625rem",
    fontWeight: 500,
    lineHeight: "1rem",
    letterSpacing: "0.025rem"
  },
  listNumber: {
    fontSize: "0.875rem",
    fontWeight: 500,
    lineHeight: "1.25rem",
    letterSpacing: "0.0021875rem"
  },
  marketingCardTitleLarge: {
    fontSize: "1.5rem",
    fontWeight: 500,
    lineHeight: "1.5rem",
    letterSpacing: "-0.01125rem"
  },
  marketingCardTitleSmall: {
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: "1.25rem",
    letterSpacing: "0rem"
  },
  metaText: {
    fontSize: "0.75rem",
    fontWeight: 400,
    lineHeight: "1rem",
    letterSpacing: "0.0625rem"
  },
  numeralLarge: {
    fontSize: "3.5rem",
    fontWeight: 500,
    lineHeight: "3.5rem",
    letterSpacing: "0rem"
  },
  numeralSmall: {
    fontSize: "2rem",
    fontWeight: 500,
    lineHeight: "2rem",
    letterSpacing: "0rem"
  },
  pageTitle: {
    fontSize: "2rem",
    fontWeight: 500,
    lineHeight: "2rem",
    letterSpacing: "-0.03rem"
  },
  sectionTitle: {
    fontSize: "1.5rem",
    fontWeight: 500,
    lineHeight: "1.5rem",
    letterSpacing: "-0.01125rem"
  },
  tabTitle: {
    fontSize: "1.5rem",
    fontWeight: 500,
    lineHeight: "1.5rem",
    letterSpacing: "-0.01125rem"
  },
  titleBarPageTitle: {
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: "1.5rem",
    letterSpacing: "0rem"
  },
  identifier: {
    fontSize: "0.75rem",
    fontWeight: 500,
    lineHeight: "1rem",
    letterSpacing: "normal"
  }
};
export {
  border,
  component,
  component2 as componentMonochrome,
  mediaQuery,
  semantic,
  semantic2 as semanticMonochrome,
  size,
  typography,
  viewport
};
